import axiosInstance from '../../../core/api/axios';

export type SubjectSeenMap = Record<string, number>;

export async function getSubjectSeen(slug: string): Promise<SubjectSeenMap> {
  try {
    const { data } = await axiosInstance.get(`/areas/${slug}/subareas/seen`, {
      params: { contentType: 'lesson' },
    });
    return data ?? {};
  } catch (e: any) {
    throw new Error(e);
  }
}
